import type { IndicatorCategory } from '@esgdash/shared';

export interface CategoryMeta {
  id: IndicatorCategory;
  label: string;
  color: string;
  group: 'Economic' | 'ESG & Sustainability' | 'Global';
}

export const CATEGORIES: CategoryMeta[] = [
  { id: 'economic', label: 'GDP & Growth', color: 'var(--accent-blue)', group: 'Economic' },
  { id: 'employment', label: 'Employment', color: 'var(--accent-green)', group: 'Economic' },
  { id: 'inflation', label: 'Inflation & Prices', color: 'var(--accent-yellow)', group: 'Economic' },
  { id: 'monetary', label: 'Interest Rates', color: 'var(--accent-purple)', group: 'Economic' },
  { id: 'trade', label: 'Trade & FX', color: 'var(--accent-blue)', group: 'Economic' },
  { id: 'environmental', label: 'Environmental', color: 'var(--accent-green)', group: 'ESG & Sustainability' },
  { id: 'energy', label: 'Energy & Resources', color: 'var(--accent-yellow)', group: 'ESG & Sustainability' },
  { id: 'social', label: 'Social Development', color: 'var(--accent-blue)', group: 'ESG & Sustainability' },
  { id: 'governance', label: 'Governance', color: 'var(--accent-purple)', group: 'ESG & Sustainability' },
  { id: 'demographics', label: 'Demographics', color: 'var(--accent-red)', group: 'Global' },
];

const BY_ID = new Map(CATEGORIES.map((c) => [c.id, c]));

export function categoryMeta(id: string): CategoryMeta | undefined {
  return BY_ID.get(id as IndicatorCategory);
}

export function categoryColor(id?: string): string {
  return (id && BY_ID.get(id as IndicatorCategory)?.color) || 'var(--accent-blue)';
}
